import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'With a brief to integrate a pool and multiple entertaining areas into a new garden a practical and timeless design was used to meet the changing needs of a young family.',
            'A poolside cabana was designed for weather protection and shade with ample bench space, storage and lighting. It provides gas, power and waste connections to allow for future conversion to a fully functional BBQ and entertaining area. A hot and cold shower is neatly fitted to the side of the cabana ensuring the space is well used.',
            'Low walling around the pool provides extra seating for parents close enough to attend to young children and the fully tiled and heated pool was constructed with a generous underwater bench seat for not only parents to relax but for children to play safely.',
            'As the rear of the house was elevated from the garden a large timber deck with automated awning cover was suspended off the rear lounge area effectively extending the floor area of the home.',
            'Boundary planting of screening hedges and feature trees will provide the privacy and structure to the garden allowing the infill colour and flowers to settle into the space well.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Design
          <br />Construction
          <br />Ongoing Maintenance
          <br />Application to Council
          <br />Structural Engineering
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          <br />Pool
          </p>
        ),
        image : '../images/projects/lane-cove-3.jpg',
        title : 'Lane Cove'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/lane-cove-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/lane-cove-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/lane-cove-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/lane-cove-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/lane-cove-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/lane-cove-6.jpg'
    },
]

const PageLaneCove = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageLaneCove